// Zoom is relative to "fit to width": 1 is the document as wide as the frame.
export const ZOOM_STEPS = [0.5, 0.75, 1, 1.25, 1.5, 2, 2.5, 3];

const EPSILON = 1e-9;

export const zoomIn = (zoom) => ZOOM_STEPS.find((step) => step > zoom + EPSILON) ?? zoom;

export const zoomOut = (zoom) =>
  [...ZOOM_STEPS].reverse().find((step) => step < zoom - EPSILON) ?? zoom;

export const canZoomIn = (zoom) => zoomIn(zoom) !== zoom;

export const canZoomOut = (zoom) => zoomOut(zoom) !== zoom;

export const zoomLabel = (zoom) => `${Math.round(zoom * 100)}%`;
